import { getAppHeight, getAppWidth, getDeviceHeight, getDeviceWidth } from "../services/CommonUtils"

export const msgType = {
    ORDER_CREATED: 1,
    ORDER_ACCEPTED: 2,
    ORDER_DECLINED: 3,
    OFFER_ACCEPTED: 4,
    OFFER_REJECTED: 5,
    LOCATION: 6,
    PAYMENT_METHOD: 7,
    TEXT: 8,
    ATTACHMENT: 9,
    PAYMENT: 10,
    CONFIRMED_WITH_OTHER_STORE: 11,
    ORDER_CANCELLED: 12,
    ORDER_DELIVERED: 13,
    UNFULFILLED: 14,
    PAYMENT_CONFIRMATION: 15,
    ORDER_DISPATCHED: 16,
    EARNED_SEHAT_SIKKE: 100
}

export const paymentModes = {
    razorpay: 'razorpay'
}

export const LocationName = {
    home: 'Home',
    work: 'Office',
    other: 'Other'
}

export const surveyEventName = {
    eConsultPaymentCancelled: "cancelled_econsult_purchase",
    aayuCardPaymentCancelled: "cancelled_aayu_card_purchase"
}

export const memberRelation = {
    "Male": [
        "Husband",
        "Father",
        "Father-in-law",
        "Son",
        "Brother",
        "Brother-in-law",
        "Son-in-law",
        "Uncle",
        "Grand Son",
        "Nephew",
        "Grand Father",
        "Cousin"
    ],
    "Female": [
        "Wife",
        "Mother",
        "Mother-in-law",
        "Sister",
        "Sister-in-law",
        "Daughter",
        "Daughter-in-law",
        "Grand Daughter",
        "Grand Mother",
        "Aunt",
        "Niece",
        "Cousin"]
}

export const StoreStaticPaymentMethodsList = [
    { name: 'Paytm', logo: 'paytm' }, { name: 'Google Pay', logo: 'gpay' },
    { name: 'Phone Pay', logo: 'phonepe' }, { name: 'Cash', logo: 'cashpayment' }]

export const FixedHeight = {
    headerHeight: 50,
    bottomFixButton: 76,
    toastBottomMargin: 56,
    bottomNavBarHeight: 70,
    homeSnackBarHeight: 64,

    totalSavingHeight: 28,
    estimatedPriceBarHeight: 58,
    selectedLocationBarHeight: 70,

    appHeight: getAppHeight(),
    deviceHeight: getDeviceHeight(),
    modalHeight: getDeviceHeight() + 60,
}

export const FixedWidth = {
    backPressIcon: 55,
    appWidth: getAppWidth(),
    deviceWidth: getDeviceWidth(),
}

export const Duration = {
    debouceTimeout: 80,
    upsertCartItemDebounce: 10,
    deviceVibration: 75,
    searchDebounce: 1000,
    transitionDuration: 400,
    animationDuration: 2000,
    tabTransitionDuration: 400,
    modalAnimationDuration: 500,
    carouselTransitionDuration: 4000,
}

export const Opaciy = {
    modalBackdropOpacity: 0.80,
    expandedImageBackdropOpacity: 0.95,
}

export const ActionFromParent = {
    placeOrder: 'place order',
    addNewAddress: 'add new address',
    selectLocationInCart: 'select location in cart',
    showLocationBottoSheet: 'show location bottomsheet',
}